import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("cabnow_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e && e.msg) || "").filter(Boolean).join(" ");
  return String(d);
}

export default api;
